module.exports = __webpack_public_path__ + "img/lemon.90113ef1.svg";